import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IBrandCount } from '../../interfaces/brand-count';
import { IBrandClickCount } from '../../interfaces/brand-click-count';
import { IEnrollmentStats } from '../../interfaces/enrollment-stats';
import { INotificationStats } from '../../interfaces/notification-stats';
import { IAccountEnrollmentTrend } from '../../interfaces/account-enrollment-trend';
import { ICsrCount } from '../../interfaces/csr-count';
// import { AppConfigService} from '../app-config.service';
import { environment } from '../../../environments/environment';
import { SharedService } from "../../shared/services/shared.service";
import { ErrorProcessorService }  from "../../shared/services/error-processor.service";
import { IMyArtifact } from '../../interfaces/my-artifact';
// import { IClickthroughStats } from 'src/app/interfaces/artifacts/click-thru-stats';

@Injectable({
  providedIn: 'root'
})
export class BrandStatsService {

  protected baseUrl = environment.apiServer.portalUrl;
  // protected basicAuth = environment.appSetting.portalAuth;
  // protected baseAuth = environment.appSetting.baseAuth;
  
  private headers = new HttpHeaders()
  // .set('Authorization', this.basicAuth);
    .set("request-origin", "csr-portal");

  // private baseHeaders = new HttpHeaders()
  // .set('Authorization', this.baseAuth);

  private clickthroughStatsUrl = '/{brandCode}/clickthroughs';

  constructor(
    private http: HttpClient, 
    private sharedService: SharedService,
    private errorProcessorService: ErrorProcessorService) {
   }

   getClickthroughsCounts(baseUrl: string, brandCodes: any, dateStart: string, dateEnd: string): Observable<IBrandClickCount[]> {
    var url = this.getStatsUrl(baseUrl) + "/clickthroughs";
    var dateTo = this.sharedService.getNextDate(dateEnd);
    var params = new HttpParams();
      if (brandCodes != null) {
        params = params.set('brandCodes', brandCodes);
      }
      if (dateStart != null) {
        params = params.set('dateStart', this.sharedService.getFormattedDate(dateStart));
      }
      if (dateEnd != null) {
        params = params.set('dateEnd', this.sharedService.getFormattedDate(dateTo));
      }
      // return this.http.get<IBrandClickCount[]>(url, {headers: this.baseHeaders, params: params, responseType: 'json'})
      return this.http.get<IBrandClickCount[]>(url, {params: params, responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
   }

  getRegisteredPasses(baseUrl: string, recentOnly: any): Observable<IBrandCount[]> {
    var url = this.getStatsUrl(baseUrl) + "/registeredPasses";
    var params = new HttpParams();
    params = params.set('recentOnly', recentOnly);
    // return this.http.get<IBrandCount[]>(url, {headers: this.baseHeaders, params: params, responseType: 'json'})
    return this.http.get<IBrandCount[]>(url, {params: params, responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getActiveAccounts(baseUrl: string): Observable<IBrandCount[]> {
    var url = this.getStatsUrl(baseUrl) + "/activeAccounts";
    // return this.http.get<IBrandCount[]>(url, {headers: this.baseHeaders, responseType: 'json'})
    return this.http.get<IBrandCount[]>(url, { responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }


  getEnrollmentStats( brandCode: string, dateStart: string, dateEnd: string): Observable<IMyArtifact>{
      var url = this.baseUrl+ "/artifacts";
      var artifactRequest:any = {
        artifactName: "EnrollmentStatistics",
        artifactParameters :{ 
          brandCodes:[brandCode], 
          dateStart:this.sharedService.getFormattedDate(dateStart), 
          dateEnd:this.sharedService.getFormattedDate(dateEnd)
        }
      }
      return this.http.post<IMyArtifact>(url,  artifactRequest , {responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
    } 

  getNotificationStats(baseUrl: string, brandCode: string, dateStart: string, dateEnd: string): Observable<IMyArtifact> {
    var url = this.baseUrl+ "/artifacts";
    var params = new HttpParams();
    var dateTo = this.sharedService.getNextDate(dateEnd);
    var artifactRequest:any = {
        artifactName: "NotificationsStatistics",
        artifactParameters :{ 
          brandCodes:[brandCode], 
          dateStart:this.sharedService.getFormattedDate(dateStart), 
          dateEnd:this.sharedService.getFormattedDate(dateTo)
        }
      }
    // return this.http.get<INotificationStats[]>(url, {headers: this.baseHeaders, params: params, responseType: 'json'})
    return  this.http.post<IMyArtifact>(url,  artifactRequest , {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getEnrollmentTrent(brandCodes: any, numOfMonths: number): Observable<IMyArtifact> {
    var url = this.baseUrl+ "/artifacts";
    var brandCodesList:string[] = [];
    if (brandCodes !== null && brandCodes !== "") {
      brandCodesList = brandCodes.split(',');
    }
    numOfMonths = numOfMonths ? Number(numOfMonths) : 12;
    var artifactRequest:any = {
        artifactName: "EnrollmentTrendsStatistics",
        artifactParameters :{ 
          brandCodes:brandCodesList, 
          numOfMonths:numOfMonths
        }
      }
    return  this.http.post<IMyArtifact>(url,  artifactRequest , {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getCsrCounts(baseUrl: string, brandCode: string, dateStart: string, dateEnd: string): Observable<ICsrCount[]> {
    var url = this.getStatsUrl(baseUrl) + "/csrs";
    var dateTo = this.sharedService.getNextDate(dateEnd);
    var params = new HttpParams();
      if (brandCode != null) {
        params = params.set('brandCode', brandCode);
      }
      if (dateStart != null) {
        params = params.set('dateStart', this.sharedService.getFormattedDate(dateStart));
      }
      if (dateEnd != null) {
        params = params.set('dateEnd', this.sharedService.getFormattedDate(dateTo));
      }
      // return this.http.get<ICsrCount[]>(url, {headers: this.baseHeaders, params: params, responseType: 'json'})
      return this.http.get<ICsrCount[]>(url, {params: params, responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
  }

 

  getClickthroughStats( brandCode: string, dateStart: string, dateEnd: string, aggregationType: string): Observable<IMyArtifact>{
    var dateEndPlus1 = this.sharedService.getNextDate(dateEnd);
      var url = this.baseUrl+ "/artifacts";
      var artifactRequest:any = {
        artifactName: "ClickThroughs",
        artifactParameters :{ 
          brandCodes:[brandCode], 
          aggrType:aggregationType, 
          dateStart:this.sharedService.getFormattedDate(dateStart), 
          dateEnd:this.sharedService.getFormattedDate(dateEndPlus1)
        }
      }
      return this.http.post<IMyArtifact>(url,  artifactRequest , {responseType: 'json'})
      .pipe(
        catchError(this.errorProcessorService.handleError)
      )
    } 

  getStatsUrl(baseUrl: string) {
      return baseUrl.replaceAll('Walletron','reports') + "/admin/stats";
  }

}
